
export interface ReplicationHubAccessResponse {
    raftCommandIndex: number;
}